(function () {
  'use strict';

  // Grille avec provision d'assurance sur une base de 100 EUR, 17 septembre 2026.
  // Seuils en poids de colis : produits + le carton Shopify par défaut de 350 g.
  var PACKAGING_GRAMS = 350;
  var PAUSED_SERVICES = {mondial: true};
  var MAX_KG = [0.5, 1, 2, 3, 4, 5, 7, 10, 15, 20, 25, 30];
  var FR_SHOP2SHOP_MAX_KG = [0.5, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  var RATES = {
    AU:{"h":[40.5,44.5,92,124,124,191,191,258.5,309,436.5,506.5,572]},
    CA:{"h":[47.5,53,57,75,86,104.5,133,160,235.5,235.5,330,380]},
    JP:{"h":[40.5,44.5,92,127,127,197.5,197.5,259,309,482,550,615]},
    CH:{"h":[19,23,25,27.5,30,32.5,43,47.5,60,69.5,79,82]},
    DE:{"s":[8.5,8.5,9,13,14,15,17,20],"m":[9.5,11,13,20,20,25.5,22,22.5],"h":[14.5,17,18.5,19.5,20.5,21.5,23.5,26.5,42.5,49,55,61],"c":[13,15.5,16.5,17.5,18.5,19,20,22]},
    AT:{"s":[10,10,10.5,14.5,15.5,16.5,18.5,21.5],"h":[16.5,20,22.5,23.5,24.5,25.5,27.5,31,48,54,60,66],"c":[15,18.5,20.5,21.5,22.5,23,24,26]},
    BE:{"s":[7.5,7.5,8,12,13,14,16,19],"m":[7,8,11.5,12,14.5,17.5,17.5,18],"h":[15,16.5,17.5,18.5,19.5,20.5,22.5,25.5,41.5,47.5,53.5,59],"c":[13,15.5,16.5,17.5,18,18.5,20,22]},
    BG:{"h":[29.5,39,44,66,66,94.5,94.5,118.5,150.5]},
    CY:{"h":[29.5,39,44,66,66,94.5,94.5,118.5,150.5]},
    HR:{"h":[29.5,39,44,66,66,94.5,94.5,118.5,150.5]},
    DK:{"h":[18,22,24,26,28.5,30.5,41,45,68.5,79.5,90.5,93.5]},
    ES:{"s":[10,10,10.5,14.5,15.5,16.5,18.5,21.5],"m":[9.5,10.5,12.5,14.5,14.5,19,19,19.5],"h":[16,20,22,23,24,25,27,30.5,47,53,59,65],"c":[14.5,18,20,21,22,22.5,23.5,25.5]},
    EE:{"h":[18,22,24,26,28.5,30.5,41,45,68.5,79.5,90.5,93.5]},
    FI:{"h":[29.5,39,44,66,66,94.5,94.5,118.5,150.5]},
    FR:{"m":[5.5,6,7.5,8,12,13.5,15,15],"h":[11.5,13.5,15,16,17.5,19,21,25,40.5,47,52.5,59],"c":[10.5,12.5,14,15.5,16.5,18,20,23.5],"s":[5.5,6,7.5,8,10,10,11,11.5,12.5,13,13.5]},
    GR:{"h":[29.5,39,44,66,66,94.5,94.5,118.5,150.5]},
    HU:{"h":[18,22,24,26,28.5,30.5,41,45,68.5,79.5,90.5,93.5]},
    IE:{"h":[24,26,27,31,31,43.5,43.5,50,67]},
    IT:{"s":[10,10,10.5,14.5,15.5,16.5,18.5,21.5],"m":[10.5,10.5,12.5,14.5,14.5,19,19,19.5],"h":[16,20,22,23,24,25,27,30.5,47,53,59,65],"c":[14.5,18,20,21.5,22,22.5,24,25.5]},
    LV:{"h":[18,22,24,26,28.5,30.5,41,45,68.5,79.5,90.5,93.5]},
    LT:{"h":[18,22,24,26,28.5,30.5,41,45,68.5,79.5,90.5,93.5]},
    LU:{"s":[8.5,8.5,9,13,14,15,17,20],"m":[7,8,11.5,12,14.5,17.5,17.5,18],"h":[14.5,17.5,18.5,19.5,20.5,21.5,23.5,26.5,43,49,55,61],"c":[13,15.5,16.5,18,18.5,19,20.5,22]},
    MT:{"h":[29.5,39,44,66,66,94.5,94.5,118.5,150.5]},
    NL:{"s":[8.5,8.5,9,13,14,15,17,20],"m":[8.5,9,11.5,12,14.5,17.5,17.5,18],"h":[14.5,17.5,18.5,19.5,20.5,21.5,23.5,26.5,43,49,55,61],"c":[13,15.5,16.5,18,18.5,19,20.5,22]},
    PL:{"h":[18,22,24,26,28.5,30.5,41,45,68.5,79.5,90.5,93.5]},
    PT:{"s":[10,11,11.5,14.5,15.5,16.5,18.5,21.5],"m":[9.5,10.5,12.5,14.5,14.5,19,19,19.5],"h":[16.5,20,22.5,23.5,24.5,25.5,27.5,31,48,54,60,66],"c":[15,18.5,20.5,21.5,22.5,23,24,26]},
    RO:{"h":[29.5,39,44,66,66,94.5,94.5,118.5,150.5]},
    SK:{"h":[18,22,24,26,28.5,30.5,41,45,68.5,79.5,90.5,93.5]},
    SI:{"h":[18,22,24,26,28.5,30.5,41,45,68.5,79.5,90.5,93.5]},
    SE:{"h":[18,22,24,26,28.5,30.5,41,45,68.5,79.5,90.5,93.5]},
    CZ:{"h":[18,22,24,26,28.5,30.5,41,45,68.5,79.5,90.5,93.5]},
    GB:{"h":[21.32,25.28,27.48,28.83,29.94,31.04,32.94,36.5,40.8,48.3,53.8,58.8]},
    US:{"h":[57.5,62.5,67,81,89.5,117,136,156,234.5,244,325.5,374]}
  };

  function bandIndex(totalWeightGrams, maximums) {
    var grams = Number(totalWeightGrams);
    if (!Number.isFinite(grams) || grams < 0) return -1;
    var kg = (grams + PACKAGING_GRAMS) / 1000;
    var bands = maximums || MAX_KG;
    for (var i = 0; i < bands.length; i += 1) {
      if (kg <= bands[i] + 0.000001) return i;
    }
    return -1;
  }

  function valueAt(values, index) {
    return Array.isArray(values) && index < values.length ? values[index] : null;
  }

  function quote(countryCode, totalWeightGrams) {
    var normalizedCountryCode = String(countryCode || '').toUpperCase();
    var countryRates = RATES[normalizedCountryCode];
    var index = bandIndex(totalWeightGrams);
    var shop2shopIndex = normalizedCountryCode === 'FR'
      ? bandIndex(totalWeightGrams, FR_SHOP2SHOP_MAX_KG)
      : index;
    if (!countryRates || index < 0) return null;
    return {
      home: valueAt(countryRates.h, index),
      shop2shop: shop2shopIndex < 0 ? null : valueAt(countryRates.s, shop2shopIndex),
      mondial: PAUSED_SERVICES.mondial ? null : valueAt(countryRates.m, index),
      colissimoRelay: valueAt(countryRates.c, index)
    };
  }

  function format(amount, locale) {
    return new Intl.NumberFormat(locale || 'fr-FR', {
      style: 'currency',
      currency: 'EUR'
    }).format(amount);
  }

  window.OUMShippingRates = {
    packagingGrams: PACKAGING_GRAMS,
    maxKg: MAX_KG,
    rates: RATES,
    quote: quote,
    format: format
  };
  document.dispatchEvent(new CustomEvent('oum:shipping-rates-ready'));
})();
